const initialState = {
  hash: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOAD_THEME':
      return { ...state, ...action.theme };
    case 'CLEAR_THEME':
      return initialState;
    default:
      return state;
  }
}
